module.exports = __webpack_public_path__ + "static/simultaantolken-4ba7b8ac2c0c5a8fdc6fc073ddea785b.jpg";